import { isMock } from '../config'
import { withOfflineCache } from '../offline-cache'
import { climaMock } from './mock'
import { climaReal } from './real'
import type { ClimaService } from './types'

const impl: ClimaService = isMock('clima') ? climaMock : climaReal

/**
 * Las instrucciones del clima estático se guardan para verlas sin conexión, como las de acceso
 * (prompt-clima.md; inventario D18). El control conectado no se sirve de la caché: sin conexión no se
 * puede cambiar la temperatura y mostrar una lectura vieja confundiría.
 */
export const climaService: ClimaService = {
  ...impl,
  getClimate: (stay, lang, signal) => withOfflineCache(stay.guestCode, 'climate', () => impl.getClimate(stay, lang, signal), (c) => c.variant === 'static'),
}
export type { ArrivalPrep, Climate, ClimateAlert, ClimateMode, ClimatePreset, ClimateResult, ClimateZone, ClimaService } from './types'
